import React from 'react';

const CTABanner: React.FC = () => {
  return (
    <section className="section-padding bg-black">
      <div className="container-max max-w-3xl">
        <h2 className="text-4xl md:text-5xl font-semibold text-white mb-6 leading-[1.05] tracking-[-0.02em]">
          Let's automate the work slowing your business down.
        </h2>
        <p className="text-lg text-neutral-400 mb-10 leading-relaxed">
          Book a free 30-minute call. We'll look at your biggest bottleneck and tell you honestly
          whether AI can fix it, and how fast.
        </p>
        <a
          href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-white hover:bg-neutral-100 text-black font-medium text-base px-7 py-3.5 rounded-full transition-colors"
        >
          Book your free call
        </a>
      </div>
    </section>
  );
};

export default CTABanner;
